import React from "react";
import { stripItems } from "../data/content";
import { shell } from "../utils/styles";
export function FeatureStrip() {
  return <div className="border-y border-line bg-moss-1" data-id="element-60" data-mp="3a7neuumdl6i1">
      <ul className={`${shell} grid grid-cols-2 gap-x-3 gap-y-[17px] py-[21px] sm:flex sm:justify-between sm:gap-5 sm:py-[23px]`} data-id="element-61" data-mp="367by3sx4vqbu">
        {stripItems.map(item => <li key={item} className="text-[10px] uppercase tracking-[0.8px] text-[#a8b59a] sm:tracking-[1.5px]" data-id="element-62" data-mp="1tdoqz7ezmgh">
            {item}
          </li>)}
      </ul>
    </div>;
}